const noPage = {
    noPage: {
        header: "Sorry, the page does not exist"
    }
};

export default noPage;
